export const DashboardCount= {
    GET_DASHBOARDCOUNT: "GET_DASHBOARDCOUNT",   
}
export const GetAllThumbnail ={
    GET_ALLTHUMBNAIL : "GET_ALLTHUMBNAIL"
}

export const CompanySitedetails = {
    GET_COMPANYSITEDETAILS: "GET_COMPANYSITEDETAILS"
}

export const getCompnaysitedata = (sitedata) => {
    return {
        type: CompanySitedetails.GET_COMPANYSITEDETAILS,
        payload: sitedata
    }
}